// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';

myw.BookmarkForm = myw.Form.extend({
    messageGroup: 'BookmarksPlugin',
    initialize(options) {
        this.app = options.app;
        this.map = options.map;

        const onZoomRequest = options.onZoomRequest
            ? options.onZoomRequest.bind(this)
            : new Function();
        const onCurrentCoordsRequest = options.onCurrentCoordsRequest
            ? options.onCurrentCoordsRequest.bind(this)
            : new Function();

        const schema = {
            messageGroup: 'CreateBookmarkDialog',
            onChange: options.onChange,
            rows: [
                {
                    components: [
                        new myw.Input({
                            name: 'myw_title',
                            value: options.model.myw_title || ''
                        }),
                        new myw.Label({
                            label: '{:basemap}',
                            cssClass: 'checkboxField',
                            wrap: new myw.Checkbox({
                                name: 'includeBasemap',
                                value: options.model.includeBasemap || false
                            })
                        }),
                        new myw.Label({
                            label: '{:layers}',
                            cssClass: 'checkboxField',
                            wrap: new myw.Checkbox({
                                name: 'includeLayers',
                                value: options.model.includeLayers || false
                            })
                        }),
                        new myw.Label({
                            label: '{:shared}',
                            cssClass: 'checkboxField',
                            visible: options.canCreateSharedBookmarks,
                            wrap: new myw.Checkbox({
                                name: 'is_private',
                                value: options.model.is_private || false
                            })
                        })
                    ]
                },
                {
                    components: [
                        new myw.Label({
                            label: '{:lat}:',
                            visible: options.showBookmarkDetail
                        }),
                        new myw.Input({
                            name: 'lat',
                            cssClass: 'medium',
                            visible: options.showBookmarkDetail,
                            value: options.model.lat
                        }),
                        new myw.Label({
                            label: '{:lng}:',
                            visible: options.showBookmarkDetail
                        }),
                        new myw.Input({
                            name: 'lng',
                            cssClass: 'medium',
                            visible: options.showBookmarkDetail,
                            value: options.model.lng
                        }),
                        new myw.Label({
                            label: '{:zoom}:',
                            visible: options.showBookmarkDetail
                        }),
                        new myw.Dropdown({
                            name: 'zoom',
                            cssClass: 'small',
                            options: [
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                17,
                                18,
                                19,
                                20,
                                21,
                                22,
                                23,
                                24,
                                25
                            ],
                            visible: options.showBookmarkDetail,
                            selected: options.model.zoom
                        }),
                        new myw.Button({
                            title: '{:setfrom}',
                            cssClass: 'action_bookmarkUpdateLocation bookmark-update-bounds',
                            visible:
                                (options.onCurrentCoordsRequest && options.showBookmarkDetail) ||
                                false,
                            onClick: onCurrentCoordsRequest
                        }),
                        new myw.Button({
                            title: '{:goto}',
                            cssClass: 'action_bookmarkZoom',
                            onClick: onZoomRequest,
                            visible: (options.onZoomRequest && options.showBookmarkDetail) || false
                        })
                    ]
                }
            ]
        };
        myw.Form.prototype.initialize.call(this, schema);
    },

    getValues() {
        const values = myw.Form.prototype.getValues.call(this);
        const currentBaseMap = this.map.getCurrentBaseMapName();
        const visibleLayerIdsString = this.map.getCurrentLayerIds().toString();
        // Using null for no selected layers instead of an empty string to differentiate it from the case when areLayersIncludedState is false.
        const currentLayers = visibleLayerIdsString.length > 0 ? visibleLayerIdsString : null;
        const layers = values.includeLayers || false ? currentLayers : '';
        const basemap = values.includeBasemap || false ? currentBaseMap : '';

        return {
            myw_title: values.myw_title,
            myw_search_val1: values.myw_title.toLowerCase(),
            myw_search_desc1: this.msg('bookmark_external_name', { name: values.myw_title }),
            username: myw.currentUser.username,
            lat: values.lat,
            lng: values.lng,
            zoom: values.zoom,
            is_private: !values.is_private,
            map_display: layers !== '' || basemap !== '' ? basemap.concat(`|${layers}`) : ''
        };
    }
});

export default myw.BookmarkForm;
